import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { WEBSITE_DATA, CURRENT_DOMAIN, TYPES } from "../../constants/dashboard";
import BackArrow from "../../assets/backArrow.svg";
import "./style.css";

const SOS = () => {
  const navigate = useNavigate();
  const sosData = WEBSITE_DATA?.innderComponents[2]?.domains?.includes(
    CURRENT_DOMAIN
  )
    ? WEBSITE_DATA.innderComponents[2]?.components[0]
    : [];
  return (
    <>
      <div className="head">
        <img
          src={BackArrow}
          className="back"
          alt="back"
          onClick={() => navigate("/")}
        />
        <img id="img" src={WEBSITE_DATA?.logo} alt="title" />
      </div>
      <div className="data">
        <h2 className="heading1">
          {/* <span className="head1">{sosData?.headingPart1}</span>{" "} */}
          <span className="head2">{sosData?.headingPart2}</span>
        </h2>
        <p className="subhead">{sosData?.subHeading}</p>
        {sosData?.componentCP
          .filter((a) => a?.domains?.includes(CURRENT_DOMAIN))
          .map((b, idx) => (
            <span key={idx}>
              {b?.type === TYPES.CARD_MEDIA_VIDEO && (
                <div className="video" key={b?.heading}>
                  <h2>{b?.heading}</h2>
                  <p>{b?.subHeading}</p>
                  <Link to={b?.mediaLink}>
                    <img src={b?.img} alt="" />
                  </Link>
                </div>
              )}
            </span>
          ))}
        <div className="explore">
          <h1 className="heading">
            {sosData?.componentCP[sosData?.componentCP?.length - 1].heading}
          </h1>
          <div className="card-links">
            {sosData?.componentCP[sosData?.componentCP?.length - 1].dataList
              .filter((a) => a?.domains?.includes(CURRENT_DOMAIN))
              .map((b, idx) => (
                <div key={idx} className="images">
                  {b?.type === TYPES.CARD_LINK && (
                    <Link to={b?.link}>
                      <img src={b?.img} alt="sa-img" className="image" />
                    </Link>
                  )}
                </div>
              ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default SOS;
